/* ============================================================
   EVOLUTION PLUS PERFORMANCE — shared mockup behaviour
   All handlers are null-safe + attribute/class driven, so any
   page gets behaviour just by using the right markup. No page
   needs its own <script> for these. (demo only — no backend)
   ============================================================ */
(function () {
  "use strict";
  /* Shopify locale (e.g. fr / fr-CA on /fr URLs) wins; otherwise the saved manual toggle, else EN. */
  var LANG = (window.EPP_LOCALE && String(window.EPP_LOCALE).toLowerCase().indexOf("fr") === 0) ? "fr" : (localStorage.getItem("epp_lang") || "en");
  var I18N = {
    follow:   { en: "Follow",    fr: "Suivre" },
    following:{ en: "Following", fr: "Suivi" },
    yourGarage:{ en: "Your garage: ", fr: "Votre garage : " },
    pickMakeModel:{ en: "Pick at least a make and model.", fr: "Choisissez au moins la marque et le modèle." },
    pickVehicle:{ en: "Select your vehicle.", fr: "Choisissez votre véhicule." },
    demoFit:  { en: "Demo: show parts that fit ", fr: "Démo : afficher les pièces compatibles avec " }
  };
  function t(key){ return (I18N[key] && I18N[key][LANG]) || I18N[key].en; }
  var $ = function (id) { return document.getElementById(id); };

  /* ---------- fitment data (demo) ---------- */
  var DATA = {
    "Subaru": {
      "WRX": { years:["2022-2024 (VB)","2015-2021 (VA)","2008-2014 (GR/GV)","2002-2007 (GD)"], engines:["FA24F 2.4T","FA20DIT 2.0T","EJ255 2.5T","EJ205 2.0T"] },
      "WRX STI": { years:["2015-2021 (VA)","2008-2014 (GR/GV)","2004-2007 (GD)"], engines:["EJ257 2.5T"] },
      "BRZ": { years:["2022-2024 (ZD8)","2013-2020 (ZC6)"], engines:["FA24 2.4","FA20 2.0"] },
      "Forester / Legacy XT": { years:["2014-2018","2005-2009"], engines:["FA24 2.4T","EJ255 2.5T"] }
    },
    "Toyota": {
      "GR86 / 86 / FR-S": { years:["2022-2024 (ZN8)","2013-2020 (ZN6)"], engines:["FA24 2.4","FA20 2.0"] },
      "Supra": { years:["2020-2024 (A90)","1993-1998 (A80)"], engines:["B58 3.0T","B48 2.0T","2JZ-GTE 3.0TT","2JZ-GE 3.0"] },
      "GR Corolla": { years:["2023-2024"], engines:["G16E-GTS 1.6T"] },
      "GR Yaris (JDM)": { years:["2020-2024"], engines:["G16E-GTS 1.6T"] },
      "AE86 Corolla": { years:["1983-1987"], engines:["4A-GE 1.6"] },
      "MR2": { years:["1991-1995 (SW20)"], engines:["3S-GTE 2.0T"] }
    },
    "Lexus": {
      "IS300 / IS350": { years:["2014-2024 (XE30)","2006-2013 (XE20)","2001-2005 (XE10)"], engines:["2GR-FSE 3.5","2JZ-GE 3.0"] },
      "IS-F": { years:["2008-2014"], engines:["2UR-GSE 5.0"] },
      "SC300 / SC400": { years:["1992-2000"], engines:["2JZ-GE 3.0","1UZ-FE 4.0"] }
    },
    "Nissan": {
      "240SX (S13/S14)": { years:["1995-1998 (S14)","1989-1994 (S13)"], engines:["KA24DE 2.4","SR20DET (swap)"] },
      "Silvia / 180SX (JDM)": { years:["1999-2002 (S15)","1989-1998 (S13/S14)"], engines:["SR20DET 2.0T"] },
      "350Z / Infiniti G35": { years:["2003-2009 (Z33/V35)"], engines:["VQ35HR 3.5","VQ35DE 3.5"] },
      "370Z / Infiniti G37": { years:["2009-2020 (Z34/V36)"], engines:["VQ37VHR 3.7"] },
      "Z": { years:["2023-2024 (RZ34)"], engines:["VR30DDTT 3.0TT"] },
      "GT-R": { years:["2009-2024 (R35)"], engines:["VR38DETT 3.8TT"] },
      "Skyline GT-R (JDM)": { years:["1999-2002 (R34)","1995-1998 (R33)","1989-1994 (R32)"], engines:["RB26DETT 2.6TT"] },
      "Stagea (JDM)": { years:["1996-2001 (WC34)"], engines:["RB25DET 2.5T (RS Four)","RB26DETT 2.6TT (260RS)","RB25DE 2.5"] }
    },
    "Honda \u00b7 Acura": {
      "Civic Si": { years:["2022-2024 (FE)","2017-2020 (FC)","2012-2015 (FB)","2006-2011 (FG/FA)","2002-2005 (EP3)"], engines:["L15B7 1.5T","K24 2.4","K20Z3 2.0","K20A3 2.0"] },
      "Civic Type R": { years:["2023-2024 (FL5)","2017-2021 (FK8)","1997-2000 (EK9 JDM)"], engines:["K20C1 2.0T","B16B 1.6"] },
      "Civic (EG/EK)": { years:["1996-2000 (EK)","1992-1995 (EG)"], engines:["D-series","B-series (swap)"] },
      "Integra": { years:["2023-2024 (DE4 Type S)","1994-2001 (DC2)","1990-1993 (DA)"], engines:["K20C1 2.0T","B18C 1.8"] },
      "S2000": { years:["2004-2009 (AP2)","2000-2003 (AP1)"], engines:["F22C 2.2","F20C 2.0"] },
      "RSX": { years:["2002-2006 (DC5)"], engines:["K20Z1 2.0","K20A2 2.0"] },
      "NSX": { years:["2017-2022 (NC1)","1991-2005 (NA1/NA2)"], engines:["JNC1 3.5TT","C30A/C32B"] }
    },
    "Mazda": {
      "MX-5 Miata": { years:["2016-2024 (ND)","2006-2015 (NC)","1998-2005 (NB)","1989-1997 (NA)"], engines:["Skyactiv 2.0","MZR 2.0","BP 1.8","B6 1.6"] },
      "RX-7": { years:["1993-2002 (FD)","1986-1992 (FC)","1979-1985 (FB)"], engines:["13B-REW TT","13B-T"] },
      "RX-8": { years:["2004-2011 (SE3P)"], engines:["13B-MSP Renesis"] },
      "Mazdaspeed3 / 6": { years:["2007-2013 (Speed3)","2006-2007 (Speed6)"], engines:["MZR 2.3 DISI Turbo"] }
    },
    "Mitsubishi": {
      "Lancer Evo X": { years:["2008-2015 (CZ4A)"], engines:["4B11T 2.0T"] },
      "Lancer Evo VIII / IX": { years:["2003-2007 (CT9A)"], engines:["4G63T 2.0T"] },
      "Lancer Evo I-III": { years:["1992-1996 (CD9A/CE9A)"], engines:["4G63T 2.0T"] },
      "Eclipse / 3000GT (DSM)": { years:["1990-1999 (Eclipse)","1991-1999 (3000GT)"], engines:["4G63T 2.0T","6G72TT 3.0TT"] }
    },
    "BMW": {
      "M3 / M4": { years:["2014-2020 (F8x)","2007-2013 (E9x)","2000-2006 (E46)","1992-1999 (E36)"], engines:["S55 3.0TT","S65 4.0","S54 3.2","S52 3.2"] },
      "335i / 135i / 535i (N54/N55)": { years:["2007-2016"], engines:["N54 3.0TT","N55 3.0T"] },
      "3-Series (325/328/330)": { years:["1992-2006 (E36/E46)"], engines:["M54 3.0","M52 2.8"] }
    },
    "Volkswagen \u00b7 Audi": {
      "Golf GTI / Golf R": { years:["2015-2024 (MK7/MK8)","2010-2014 (MK6)","2006-2009 (MK5)"], engines:["EA888 2.0T","EA113 2.0T"] },
      "Jetta GLI": { years:["2006-2024"], engines:["EA888 2.0T"] },
      "Audi A3 / S3": { years:["2015-2024 (8V/8Y)","2006-2013 (8P)"], engines:["EA888 2.0T"] },
      "Audi S4 / TT": { years:["2008-2024"], engines:["EA839 3.0T","EA888 2.0T"] }
    },
    "Hyundai": {
      "Genesis Coupe": { years:["2010-2016 (BK)"], engines:["Theta II 2.0T","Lambda 3.8"] },
      "Veloster N / Elantra N": { years:["2019-2024"], engines:["G4KH 2.0T"] }
    }
  };

  /* finder → faceted collection routing: make → its vehicle collection, model → real Model: tag (built by cross-referencing DATA against catalog tags) */
  var MAKE_COL = {"Subaru": "vehicle-subaru", "Toyota": "vehicle-toyota", "Lexus": "vehicle-lexus", "Nissan": "vehicle-nissan", "Honda · Acura": "vehicle-honda", "Mazda": "vehicle-mazda", "Mitsubishi": "vehicle-mitsubishi", "BMW": "vehicle-bmw", "Volkswagen · Audi": "vehicle-volkswagen", "Hyundai": "vehicle-hyundai"};
  var MODEL_TAG = {"Subaru": {"WRX": "model-wrx", "WRX STI": "model-wrx", "BRZ": "model-brz", "Forester / Legacy XT": "model-legacy"}, "Toyota": {"GR86 / 86 / FR-S": "model-86", "Supra": "model-supra", "GR Corolla": "model-corolla", "GR Yaris (JDM)": "model-yaris", "AE86 Corolla": "model-corolla", "MR2": "model-mr2"}, "Lexus": {"IS300 / IS350": "model-is350", "IS-F": "model-is-f", "SC300 / SC400": "model-sc400"}, "Nissan": {"240SX (S13/S14)": "model-240sx", "Silvia / 180SX (JDM)": "model-silvia", "350Z / Infiniti G35": "model-350z", "370Z / Infiniti G37": "model-370z", "Z": "model-z", "GT-R": "model-gt-r", "Skyline GT-R (JDM)": "model-skyline-gt-r", "Stagea (JDM)": "model-stagea"}, "Honda · Acura": {"Civic Si": "model-civic", "Civic Type R": "model-civic", "Civic (EG/EK)": "model-civic", "Integra": "model-integra", "S2000": "model-s2000", "RSX": "model-rsx"}, "Mazda": {"MX-5 Miata": "model-mx-5", "RX-7": "model-rx-7", "RX-8": "model-rx-8"}, "Mitsubishi": {"Lancer Evo X": "model-lancer", "Lancer Evo VIII / IX": "model-lancer", "Lancer Evo I-III": "model-lancer", "Eclipse / 3000GT (DSM)": "model-eclipse"}, "BMW": {"M3 / M4": "model-m3", "335i / 135i / 535i (N54/N55)": "model-135i", "3-Series (325/328/330)": "model-3-series"}, "Volkswagen · Audi": {"Golf GTI / Golf R": "model-golf", "Jetta GLI": "model-jetta"}, "Hyundai": {"Genesis Coupe": "model-genesis-coupe", "Veloster N / Elantra N": "model-elantra"}};

  /* ---------- garage (localStorage) ---------- */
  function getGarage(){ try { return JSON.parse(localStorage.getItem("epp_garage") || "[]"); } catch (e) { return []; } }
  function setGarage(g){ localStorage.setItem("epp_garage", JSON.stringify(g)); renderGarage(); }
  // cross-store garage sync (rewards.js): structured fields per saved label + mutation events
  function garageMeta(){ try { return JSON.parse(localStorage.getItem("epp_garage_meta") || "{}"); } catch (e) { return {}; } }
  function garageEvent(kind, detail){ try { document.dispatchEvent(new CustomEvent("epp:garage:" + kind, { detail: detail })); } catch (e) {} }
  window.EPPGarage = { get: getGarage, set: setGarage, meta: garageMeta };
  function activeVehicle(){ var g = getGarage(); return g.length ? g[g.length - 1] : null; }
  function renderGarage(){
    var g = getGarage();
    document.querySelectorAll("#garageCount, [data-garage-count]").forEach(function (el) { el.textContent = g.length; });
    var v = activeVehicle();
    // home/finder confirmation line
    var msg = $("garageMsg"), msgText = $("garageMsgText");
    if (msg && msgText) {
      if (v) { msgText.textContent = t("yourGarage") + v; msg.classList.add("show"); }
      else { msg.classList.remove("show"); }
    }
    // any element that wants the active vehicle string
    document.querySelectorAll("[data-active-vehicle]").forEach(function (el) {
      el.textContent = v || el.getAttribute("data-empty") || "—";
    });
    // garage-page vehicle list (last saved = active for fitment)
    function escv(s){ return String(s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
    document.querySelectorAll("[data-garage-list]").forEach(function (list) {
      list.innerHTML = g.map(function (veh, i) {
        var isActive = i === g.length - 1;
        return '<div class="wal-row">' +
          '<span class="ico" aria-hidden="true">🚗</span>' +
          '<div class="info"><div class="t">' + escv(veh) +
            (isActive ? ' <span class="badge badge--ca">✓ ' + (LANG === "fr" ? "Actif pour l’ajustement" : "Active for fitment") + '</span>' : '') +
          '</div></div>' +
          '<div class="acts">' +
            (isActive ? '' : '<button class="btn btn-ghost btn-sm" data-garage-activate="' + i + '">' + (LANG === "fr" ? "Rendre actif" : "Set active") + '</button>') +
            '<button class="btn btn-ghost btn-sm" data-garage-remove="' + i + '">' + (LANG === "fr" ? "Retirer" : "Remove") + '</button>' +
          '</div></div>';
      }).join("");
    });
    document.querySelectorAll("[data-garage-empty]").forEach(function (el) { el.hidden = g.length > 0; });
  }
  document.addEventListener("click", function (e) {
    if (!e.target || !e.target.closest) return;
    var rm = e.target.closest("[data-garage-remove]");
    if (rm) { var g = getGarage(); var gone = g.splice(parseInt(rm.getAttribute("data-garage-remove"), 10), 1)[0]; setGarage(g); if (gone) garageEvent("remove", { label: gone }); return; }
    var ac = e.target.closest("[data-garage-activate]");
    if (ac) { var g2 = getGarage(), v2 = g2.splice(parseInt(ac.getAttribute("data-garage-activate"), 10), 1)[0]; if (v2) { g2.push(v2); } setGarage(g2); if (v2) garageEvent("activate", { label: v2 }); }
  });

  /* ---------- garage finder (home + collection) ---------- */
  function fillSelect(sel, items, phEn, phFr){
    if (!sel) return;
    sel.innerHTML = "";
    sel.setAttribute("data-en-al", phEn); sel.setAttribute("data-fr-al", phFr);
    sel.setAttribute("aria-label", LANG === "fr" ? phFr : phEn);
    var ph = document.createElement("option");
    ph.value = ""; ph.textContent = (LANG === "fr" ? phFr : phEn);
    ph.setAttribute("data-en", phEn); ph.setAttribute("data-fr", phFr);
    sel.appendChild(ph);
    items.forEach(function (v) { var o = document.createElement("option"); o.value = v; o.textContent = v; sel.appendChild(o); });
  }
  function wireFinder(){
    var selMake = $("selMake"), selModel = $("selModel"), selYear = $("selYear"), selEngine = $("selEngine");
    if (!selMake) return;
    fillSelect(selMake, Object.keys(DATA), "Make", "Marque");
    selMake.addEventListener("change", function () {
      selModel.disabled = !selMake.value; selYear.disabled = true; selEngine.disabled = true;
      fillSelect(selYear, [], "Year", "Année"); fillSelect(selEngine, [], "Engine", "Moteur");
      fillSelect(selModel, selMake.value ? Object.keys(DATA[selMake.value]) : [], "Model", "Modèle");
    });
    selModel.addEventListener("change", function () {
      var m = DATA[selMake.value] && DATA[selMake.value][selModel.value];
      selYear.disabled = !selModel.value; selEngine.disabled = true; fillSelect(selEngine, [], "Engine", "Moteur");
      fillSelect(selYear, m ? m.years : [], "Year", "Année");
    });
    selYear.addEventListener("change", function () {
      var m = DATA[selMake.value] && DATA[selMake.value][selModel.value];
      selEngine.disabled = !selYear.value;
      if (m) fillSelect(selEngine, m.engines, "Engine", "Moteur");
    });
    function current(){ return [selYear.value, selMake.value, selModel.value, selEngine.value].filter(Boolean).join(" "); }
    var saveBtn = $("saveBtn"), findBtn = $("findBtn");
    if (saveBtn) saveBtn.addEventListener("click", function () {
      if (!selMake.value || !selModel.value) { alert(t("pickMakeModel")); return; }
      var v = current(); var g = getGarage(); if (g.indexOf(v) === -1) g.push(v); setGarage(g);
      var meta = garageMeta();
      meta[v] = { year: parseInt(selYear.value, 10) || null, make: selMake.value, model: selModel.value, engine: selEngine.value || null };
      localStorage.setItem("epp_garage_meta", JSON.stringify(meta));
      garageEvent("add", { label: v });
    });
    if (findBtn) findBtn.addEventListener("click", function () {
      if (!selMake.value) { alert(t("pickVehicle")); return; }
      var root = ((window.Shopify && Shopify.routes && Shopify.routes.root) || "/").replace(/\/$/, "");
      // Prefer the make's faceted collection (Brand/Category/Model filters), pre-filtered by the
      // model's real Model: tag when it maps. Falls back to search only for unmapped makes.
      var col = MAKE_COL[selMake.value];
      if (col) {
        var url = root + "/collections/" + col;
        var mt = MODEL_TAG[selMake.value] && MODEL_TAG[selMake.value][selModel.value];
        if (mt) url += "/" + mt;
        window.location.href = url;
        return;
      }
      var make = selMake.value.split("·")[0].trim();
      var model = (selModel.value || "").split("/")[0].replace(/\([^)]*\)/g, "").replace(/\bJDM\b/gi, "").replace(/\s+/g, " ").trim();
      var q = (!model || model.length < 4) ? (make + " " + model).trim() : model;
      window.location.href = root + "/search?type=product&q=" + encodeURIComponent(q);
    });
  }

  /* ---------- language toggle (global) ---------- */
  function applyLang(){
    document.documentElement.lang = LANG;
    document.querySelectorAll("[data-en]").forEach(function (el) {
      var val = LANG === "fr" ? el.getAttribute("data-fr") : el.getAttribute("data-en");
      if (val != null) { if (/<.+>/.test(val)) el.innerHTML = val; else el.textContent = val; }
    });
    document.querySelectorAll("[data-en-ph]").forEach(function (el) {
      var p = LANG === "fr" ? el.getAttribute("data-fr-ph") : el.getAttribute("data-en-ph");
      if (p != null) el.setAttribute("placeholder", p);
    });
    document.querySelectorAll("[data-en-al]").forEach(function (el) {
      var a = LANG === "fr" ? el.getAttribute("data-fr-al") : el.getAttribute("data-en-al");
      if (a != null) el.setAttribute("aria-label", a);
    });
    document.querySelectorAll(".langtoggle button").forEach(function (b) { b.classList.toggle("active", b.dataset.lang === LANG); });
    renderFollowLabels();
    renderGarage();
  }
  function wireLang(){
    document.querySelectorAll(".langtoggle button").forEach(function (b) {
      b.addEventListener("click", function () { LANG = b.dataset.lang; localStorage.setItem("epp_lang", LANG); applyLang(); });
    });
  }

  /* ---------- social: like buttons ---------- */
  function wireLikes(){
    document.querySelectorAll("[data-like]").forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault(); e.stopPropagation();
        var active = btn.classList.toggle("is-active");
        var c = btn.querySelector("[data-like-count]");
        if (c) { var n = parseInt(c.textContent.replace(/[^0-9]/g, ""), 10) || 0; c.textContent = active ? (n + 1) : (n - 1); }
      });
    });
  }

  /* ---------- social: follow buttons ---------- */
  function renderFollowLabels(){
    document.querySelectorAll("[data-follow]").forEach(function (btn) {
      var lbl = btn.querySelector("[data-follow-label]") || btn;
      var on = btn.classList.contains("is-following");
      lbl.textContent = on ? t("following") : t("follow");
    });
  }
  function wireFollows(){
    document.querySelectorAll("[data-follow]").forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        btn.classList.toggle("is-following");
        btn.classList.toggle("btn-red");
        btn.classList.toggle("btn-ghost");
        renderFollowLabels();
      });
    });
  }

  /* ---------- gallery (PDP / build) ---------- */
  function wireGalleries(){
    document.querySelectorAll(".gallery").forEach(function (g) {
      var main = g.querySelector(".gallery__main .ph");
      g.querySelectorAll(".gallery__thumb").forEach(function (th) {
        th.addEventListener("click", function () {
          g.querySelectorAll(".gallery__thumb").forEach(function (x) { x.classList.remove("is-active"); });
          th.classList.add("is-active");
          if (main) main.textContent = th.getAttribute("data-label") || th.textContent;
        });
      });
    });
  }

  /* ---------- accordions ---------- */
  function wireAccordions(){
    document.querySelectorAll(".accordion__head").forEach(function (h) {
      h.addEventListener("click", function () {
        var item = h.closest(".accordion__item");
        if (item) item.classList.toggle("is-open");
      });
    });
  }

  /* ---------- tabs ---------- */
  function wireTabs(){
    document.querySelectorAll(".tabs").forEach(function (group) {
      var tabs = group.querySelectorAll(".tab");
      tabs.forEach(function (tab) {
        tab.addEventListener("click", function () {
          var name = tab.getAttribute("data-tab");
          tabs.forEach(function (x) { x.classList.remove("is-active"); });
          tab.classList.add("is-active");
          document.querySelectorAll(".tabpanel").forEach(function (p) {
            p.classList.toggle("is-active", p.getAttribute("data-panel") === name);
          });
        });
      });
    });
    // open a tab from the URL hash, e.g. /account/login#signup or /pages/garage#orders
    var h = (location.hash || "").replace("#", "");
    if (h) { var ht = document.querySelector('.tab[data-tab="' + h + '"]'); if (ht) ht.click(); }
  }

  /* ---------- filter chips (visual) ---------- */
  function wireChips(){
    document.querySelectorAll(".filter-chip").forEach(function (chip) {
      chip.addEventListener("click", function () { chip.classList.toggle("is-active"); });
    });
  }

  /* ---------- qty steppers ---------- */
  function wireQty(){
    document.querySelectorAll(".qty").forEach(function (q) {
      var input = q.querySelector("input");
      q.querySelectorAll("button[data-step]").forEach(function (b) {
        b.addEventListener("click", function () {
          var step = parseInt(b.getAttribute("data-step"), 10) || 0;
          var n = Math.max(1, (parseInt(input.value, 10) || 1) + step);
          input.value = n;
        });
      });
    });
  }

  /* ---------- comment form (demo append) ---------- */
  function wireComments(){
    document.querySelectorAll(".commentform").forEach(function (form) {
      var input = form.querySelector("input");
      var list = document.querySelector(".comments");
      function add(){
        var v = input.value.trim(); if (!v || !list) return;
        var c = document.createElement("div"); c.className = "comment";
        c.innerHTML = '<div class="avatar avatar--sm">YOU</div><div class="cbody"><div class="who">You</div><div class="tx"></div></div>';
        c.querySelector(".tx").textContent = v;
        list.appendChild(c); input.value = "";
      }
      form.addEventListener("submit", function (e) { e.preventDefault(); add(); });
      var btn = form.querySelector("button");
      if (btn) btn.addEventListener("click", function (e) { e.preventDefault(); add(); });
    });
  }

  /* ---------- mobile nav ---------- */
  function wireMenu(){
    document.querySelectorAll(".menu-toggle").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var nav = document.querySelector(".mobile-nav");
        if (nav) nav.classList.toggle("open");
      });
    });
  }

  /* ---------- non-blocking welcome promo ---------- */
  function hidePromo(el){ el.classList.remove("promo--in"); setTimeout(function () { if (el && el.parentNode) el.remove(); }, 500); }
  function renderPromo(){
    if (document.body.dataset.page === "login") return;           // already on the auth page
    if (document.body.dataset.page === "rewards") return;         // rewards page hosts the live sign-in the CTA points at
    if (localStorage.getItem("epp_offer_claimed")) return;        // already claimed
    if (sessionStorage.getItem("epp_promo_seen")) return;         // shown once this session
    if (document.querySelector(".promo")) return;
    var el = document.createElement("div");
    el.className = "promo"; el.setAttribute("role", "complementary");
    el.innerHTML =
      '<button class="x" aria-label="Close" data-promo-close>&times;</button>' +
      '<div class="big">5%</div>' +
      '<h4 data-en="Off your first order" data-fr="Sur votre 1re commande">Off your first order</h4>' +
      '<p data-en="Create your Garage and add your ride — we’ll take 5% off your first order." data-fr="Créez votre garage, ajoutez votre véhicule et obtenez 5 % de rabais sur votre première commande.">Create your Garage and add your ride.</p>' +
      '<a class="btn btn-red" href="' + ((window.EPP_ROOT || "/") + "pages/rewards#signup") + '" data-promo-claim data-en="Claim 5% — create Garage" data-fr="Obtenir 5 % — créer mon garage">Claim 5%</a>' +
      '<button class="later" data-promo-close data-en="Maybe later" data-fr="Plus tard">Maybe later</button>';
    document.body.appendChild(el);
    el.querySelectorAll("[data-promo-close]").forEach(function (b) { b.addEventListener("click", function () { hidePromo(el); }); });
    var claim = el.querySelector("[data-promo-claim]");
    if (claim) claim.addEventListener("click", function () { localStorage.setItem("epp_offer_claimed", "1"); });
    applyLang(); // resolve data-en/fr on the injected nodes
    var shown = false;
    function show(){ if (shown) return; shown = true; sessionStorage.setItem("epp_promo_seen", "1"); cleanup(); requestAnimationFrame(function () { el.classList.add("promo--in"); }); }
    function onScroll(){ var sc = window.scrollY || document.documentElement.scrollTop; var h = document.documentElement.scrollHeight - window.innerHeight; if (h > 0 && sc / h > 0.30) show(); }
    function cleanup(){ window.removeEventListener("scroll", onScroll); clearTimeout(timer); }
    var timer = setTimeout(show, 9000);
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  /* ---------- selectable option cards (checkout shipping/payment) ---------- */
  function wireOptcards(){
    document.querySelectorAll(".optcard").forEach(function (c) {
      c.addEventListener("click", function () {
        var group = c.parentNode;
        group.querySelectorAll(":scope > .optcard").forEach(function (x) { x.classList.remove("is-sel"); });
        c.classList.add("is-sel");
      });
    });
  }

  /* single permanent light theme — toggle removed; tokens live in epp.css :root.
     Clear any stale saved theme so old data-theme overrides never apply. */
  try { localStorage.removeItem("epp_theme"); } catch (e) {}
  document.documentElement.removeAttribute("data-theme");

  /* ---------- a11y: skip-to-content link ---------- */
  function injectSkipLink(){
    if (document.querySelector(".skip-link")) return;
    var a = document.createElement("a");
    a.className = "skip-link";
    a.setAttribute("data-en", "Skip to content"); a.setAttribute("data-fr", "Aller au contenu");
    a.textContent = LANG === "fr" ? "Aller au contenu" : "Skip to content";
    document.body.insertBefore(a, document.body.firstChild);
    var h = document.querySelector("header"); var m = h ? h.nextElementSibling : null;
    while (m && m.tagName === "NAV") m = m.nextElementSibling;   // skip the mobile-nav
    if (m) { if (!m.id) m.id = "epp-main"; a.href = "#" + m.id; m.setAttribute("tabindex", "-1"); }
    else { a.href = "#"; }
  }

  /* ---------- Law 25 cookie consent (granular · opt-in · revisitable) ---------- */
  function getConsent(){ try { return JSON.parse(localStorage.getItem("epp_consent") || "null"); } catch (e) { return null; } }
  function applyConsent(c){
    window.eppConsent = c;
    /* GA4 Consent Mode v2 — grant storage only for what the visitor allowed (epp-analytics.liquid sets the default-denied state) */
    try {
      if (window.gtag) gtag('consent', 'update', {
        'analytics_storage': c.analytics ? 'granted' : 'denied',
        'ad_storage': c.marketing ? 'granted' : 'denied',
        'ad_user_data': c.marketing ? 'granted' : 'denied',
        'ad_personalization': c.marketing ? 'granted' : 'denied'
      });
    } catch (e) {}
    /* Bridge to Shopify's native Customer Privacy API (gates Shopify-managed pixels) */
    try {
      if (window.Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.setTrackingConsent) {
        Shopify.customerPrivacy.setTrackingConsent({ analytics: !!c.analytics, marketing: !!c.marketing, preferences: !!c.analytics, sale_of_data: !!c.marketing }, function(){});
      }
    } catch (e) {}
  }
  function ccClose(){ ["cc-banner", "cc-modal"].forEach(function (cl) { var e = document.querySelector("." + cl); if (e) e.remove(); }); }
  function saveConsent(c){ c.necessary = true; c.ts = new Date().toISOString(); localStorage.setItem("epp_consent", JSON.stringify(c)); applyConsent(c); ccClose(); }
  function consentBanner(force){
    if (!force && getConsent()) { applyConsent(getConsent()); return; }      // already decided
    if (document.querySelector(".cc-banner")) return;
    var b = document.createElement("div"); b.className = "cc-banner"; b.setAttribute("role", "region"); b.setAttribute("aria-label", "Cookie notice");
    b.innerHTML = '<div class="cc-msg" data-en="We use cookies to run the store and — only with your consent — to measure and personalize. You choose." data-fr="Nous utilisons des témoins pour faire fonctionner la boutique et — uniquement avec votre consentement — pour mesurer et personnaliser. À vous de choisir.">We use cookies…</div>' +
      '<div class="cc-btns">' +
      '<button class="btn btn-ghost btn-sm" data-cc="necessary" data-en="Necessary only" data-fr="Essentiels seulement">Necessary only</button>' +
      '<button class="btn btn-red btn-sm" data-cc="all" data-en="Accept all" data-fr="Tout accepter">Accept all</button></div>';
    document.body.appendChild(b);
    b.querySelector('[data-cc="all"]').addEventListener("click", function () { saveConsent({ analytics: true, marketing: true }); });
    b.querySelector('[data-cc="necessary"]').addEventListener("click", function () { saveConsent({ analytics: false, marketing: false }); });
    applyLang();
  }
  function injectCookieSettingsLink(){
    document.querySelectorAll(".legal").forEach(function (row) {
      if (row.querySelector("[data-cc-open]")) return;
      var a = document.createElement("a"); a.href = "#"; a.setAttribute("data-cc-open", "");
      a.setAttribute("data-en", "Cookie settings"); a.setAttribute("data-fr", "Réglages des témoins"); a.textContent = "Cookie settings";
      a.addEventListener("click", function (e) { e.preventDefault(); consentBanner(true); });
      row.appendChild(a);
    });
  }

  /* ---------- faceted filter sidebar ---------- */
  function wireFacets(){
    // accordion groups
    document.querySelectorAll(".fac-head").forEach(function (h) {
      h.addEventListener("click", function () {
        h.setAttribute("aria-expanded", h.getAttribute("aria-expanded") === "false" ? "true" : "false");
      });
    });
    // show all / show less — keep data-en/data-fr synced to state so the language toggle stays correct
    document.querySelectorAll(".fac-more").forEach(function (btn) {
      var list = btn.parentNode.querySelector(".fac-list");
      if (!list) return;
      btn.addEventListener("click", function () {
        var expanded = list.classList.toggle("is-expanded");
        var en = expanded ? btn.getAttribute("data-less-en") : btn.getAttribute("data-more-en");
        var fr = expanded ? btn.getAttribute("data-less-fr") : btn.getAttribute("data-more-fr");
        if (en) btn.setAttribute("data-en", en);
        if (fr) btn.setAttribute("data-fr", fr);
        btn.textContent = (LANG === "fr" ? fr : en) || btn.textContent;
      });
    });
    // mobile off-canvas drawer — accessible dialog + iOS-safe scroll lock
    var side = document.getElementById("eppFacets");
    var overlay = document.querySelector(".fac-overlay");
    var opener = null, savedY = 0;
    function openDrawer(e){
      if (!side) return;
      opener = (e && e.currentTarget) || null;
      side.classList.add("is-open");
      if (overlay) overlay.classList.add("is-open");
      side.setAttribute("role", "dialog");
      side.setAttribute("aria-modal", "true");
      savedY = window.scrollY || document.documentElement.scrollTop || 0;
      document.body.style.top = "-" + savedY + "px";
      document.body.classList.add("fac-locked");
      var cb = document.getElementById("facClose"); if (cb) cb.focus();
    }
    function closeDrawer(){
      if (side) { side.classList.remove("is-open"); side.removeAttribute("role"); side.removeAttribute("aria-modal"); }
      if (overlay) overlay.classList.remove("is-open");
      if (document.body.classList.contains("fac-locked")) {
        document.body.classList.remove("fac-locked");
        document.body.style.top = "";
        window.scrollTo(0, savedY);
      }
      if (opener) { opener.focus(); opener = null; }
    }
    document.querySelectorAll("[data-fac-open]").forEach(function (b) { b.addEventListener("click", openDrawer); });
    var closeBtn = document.getElementById("facClose"); if (closeBtn) closeBtn.addEventListener("click", closeDrawer);
    if (overlay) overlay.addEventListener("click", closeDrawer);
    document.addEventListener("keydown", function (e) { if (e.key === "Escape" && side && side.classList.contains("is-open")) closeDrawer(); });
    // if the viewport grows past the mobile breakpoint while open, unlock cleanly
    if (window.matchMedia) {
      var mq = window.matchMedia("(min-width:901px)");
      var onMq = function (e) { if (e.matches && side && side.classList.contains("is-open")) closeDrawer(); };
      if (mq.addEventListener) mq.addEventListener("change", onMq); else if (mq.addListener) mq.addListener(onMq);
    }
    // sort dropdown → navigate (option values are full URLs preserving filters)
    var sort = document.getElementById("facSort");
    if (sort) sort.addEventListener("change", function () { if (sort.value) window.location.href = sort.value; });
  }

  /* ---------- boot ---------- */
  function boot(){
    injectSkipLink();
    wireFinder(); wireLang(); wireLikes(); wireFollows(); wireGalleries();
    wireAccordions(); wireTabs(); wireChips(); wireQty(); wireComments(); wireMenu(); wireOptcards();
    wireFacets();
    applyLang(); // also calls renderGarage + renderFollowLabels
    consentBanner(); injectCookieSettingsLink();
    renderPromo();
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
